import EcoImg from 'eco-design/base/eco-img';
import { useOnceInView } from '../useOnceInView';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';

function TheComp() {
    const { t } = useLang('theProduct');
    const { locale = 'us' } = getLocal();
    const isZa = locale === 'za';

    const list = [
        {
            title: t('E_item1_title'),
            desc: t('E_item1_desc'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767839778645-6nbik4-compressed-%E8%A1%8C%E8%BD%A6%E5%BF%AB%E5%85%85KSP/PC_1.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1767839888051-nukt55-compressed-Frame%201612707689.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767840113082-5c6bpj-compressed-Frame%201612707689.jpg',
        },
        {
            title: t('E_item2_title'),
            desc: t('E_item2_desc'),
            pc: isZa
                ? 'https://websiteoss.ecoflow.com/figma-uploads/1788928266144-80pr8q-compressed-%E8%A1%8C%E8%BD%A6%E5%BF%AB%E5%85%85KSP/PC_2.webp'
                : 'https://websiteoss.ecoflow.com/figma-uploads/1767839786988-txzix7-compressed-%E8%A1%8C%E8%BD%A6%E5%BF%AB%E5%85%85KSP/PC_2.jpg',
            pad: isZa
                ? 'https://websiteoss.ecoflow.com/figma-uploads/1788928274987-1bcrou-compressed-Frame%201612707695.webp'
                : 'https://websiteoss.ecoflow.com/figma-uploads/1767839927597-31s46d-compressed-Frame%201612707695.jpg',
            h5: isZa
                ? 'https://websiteoss.ecoflow.com/figma-uploads/1788928274987-1bcrou-compressed-Frame%201612707695.webp'
                : 'https://websiteoss.ecoflow.com/figma-uploads/1767840127161-o94uu9-compressed-Frame%201612707695.jpg',
        },
        {
            title: t('E_item3_title'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767839791594-wecpd0-compressed-%E8%A1%8C%E8%BD%A6%E5%BF%AB%E5%85%85KSP/PC_3.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1767839932406-7is2cn-compressed-Frame%201612707626.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767840141261-pu2qxa-compressed-Frame%201612707626.jpg',
        },
        {
            title: t('E_item4_title'),
            pc: isZa
                ? 'https://websiteoss.ecoflow.com/figma-uploads/1788928268619-1iug73-compressed-%E8%A1%8C%E8%BD%A6%E5%BF%AB%E5%85%85KSP/PC_4.webp'
                : 'https://websiteoss.ecoflow.com/figma-uploads/1767839795578-xui024-compressed-%E8%A1%8C%E8%BD%A6%E5%BF%AB%E5%85%85KSP/PC_4.jpg',
            pad: isZa
                ? 'https://websiteoss.ecoflow.com/figma-uploads/1788928280976-s8seam-compressed-Frame%201612707624.webp'
                : 'https://websiteoss.ecoflow.com/figma-uploads/1767839895488-aan4o8-compressed-Frame%201612707624.jpg',
            h5: isZa
                ? 'https://websiteoss.ecoflow.com/figma-uploads/1788928280976-s8seam-compressed-Frame%201612707624.webp'
                : 'https://websiteoss.ecoflow.com/figma-uploads/1767840152243-vvx6ft-compressed-Frame%201612707624.jpg',
        },
        {
            title: t('E_item5_title'),
            desc: t('E_item5_desc'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767839800223-c6ewsc-compressed-%E8%A1%8C%E8%BD%A6%E5%BF%AB%E5%85%85KSP/PC_5.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1767839923019-ovt42w-compressed-Frame%201612707696.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767840162499-kuxpiv-compressed-Frame%201612707696.jpg',
        },
        {
            title: t('E_item6_title'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767839803181-fbkm4u-compressed-%E8%A1%8C%E8%BD%A6%E5%BF%AB%E5%85%85KSP/PC_6.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1767839936019-7xa0ed-compressed-Frame%201612707627.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767840172435-dnilbg-compressed-Frame%201612707627.jpg',
        },
    ];

    useOnceInView('.on-the-road-E .E-title', () => {
        document.querySelector('.E-title')?.classList.add('enter');
        document.querySelector('.E-grid')?.classList.add('enter');
    });

    return (
        <section
            className={`${css.section} on-the-road-E GtmModuleData-section`}
            id="on-the-road-E"
            data-section-id={'on-the-road-E'}
            data-section-title={t('E_title')}
        >
            <div className="E-title ani-1">{t('E_title')}</div>
            <div className="E-grid ani-2">
                {list.map((i, idx) => (
                    <div className="E-grid-item" key={idx}>
                        <EcoImg pc={i.pc} pad={i.pad} h5={i.h5} isOpenLazy />
                        <div className="E-grid-item-info">
                            {i.title && <div className="E-grid-title">{i.title}</div>}
                            {i.desc && <div className="E-grid-desc">{i.desc}</div>}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default TheComp;
